"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var _AnalyticsViewsAPI = _interopRequireDefault(require("../api/AnalyticsViewsAPI"));

var _AnalyticsViewsActions = require("../actions/AnalyticsViewsActions");

var deleteViewEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(_ref) {
    var id = _ref.id;
    return _AnalyticsViewsAPI.default.deleteFilter(id);
  },
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.DELETE_VIEW,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _AnalyticsViewsActions.DeleteView
}));
var permanentlyDeleteViewEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(_ref2) {
    var id = _ref2.id;
    return _AnalyticsViewsAPI.default.permanentlyDeleteFilter(id);
  },
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.PERMANENTLY_DELETE_VIEW,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _AnalyticsViewsActions.PermanentlyDeleteView
}));
var restoreViewEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(_ref3) {
    var id = _ref3.id;
    return _AnalyticsViewsAPI.default.restoreFilter(id);
  },
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.RESTORE_VIEW,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _AnalyticsViewsActions.RestoreView
}));
var addViewEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(filter) {
    return _AnalyticsViewsAPI.default.createFilter(filter);
  },
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.ADD_VIEW,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _AnalyticsViewsActions.AddView
}));
var updateViewEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: function apiFunction(filter) {
    return _AnalyticsViewsAPI.default.updateFilter(filter);
  },
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.UPDATE_VIEW,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _AnalyticsViewsActions.UpdateView
}));
var fetchAnalyticsViews = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _AnalyticsViewsAPI.default.getAllFilters,
  initiatingActionType: _AnalyticsViewsActions.AnalyticsViewsActionTypes.FETCH_VIEWS,
  requestStatusSelector: _requestStatusSelectors.getFetchViewsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _AnalyticsViewsActions.FetchViews
}));

var _default = (0, _reduxObservable.combineEpics)(fetchAnalyticsViews, deleteViewEpic, permanentlyDeleteViewEpic, updateViewEpic, restoreViewEpic, addViewEpic);

exports.default = _default;
module.exports = exports.default;